const baseUrl = process.env.NODE_ENV === "production" ?
    'https://api-bvs-autentification.herokuapp.com/ws/v1':
    'https://api-bvs-autentification.herokuapp.com/ws/v1';

export default baseUrl